export default __webpack_public_path__ + "static/media/sensoan_logo_white.d6e7381d.png";